// extracted by css-extract-rspack-plugin
export default {"modal":"modal-Sjc6Xy","user-info":"user-info-qAvRt0","userInfo":"user-info-qAvRt0","tag":"tag-ongUia"};